"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function AboutSnapshot() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-background py-16 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {}
        <div ref={leftRef} className={leftVisible ? "animate-fade-in-up" : "opacity-0"}>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-6">
            Craftsmanship You Can Trust
          </h2>
          <p className="text-foreground/80 text-lg leading-relaxed mb-6">
            K&M Mechanical Services brings over 15 years of expertise to every 
            HVAC project in Pittsburgh, PA. Our experienced technicians combine 
            advanced diagnostics with impeccable craftsmanship to deliver 
            energy-efficient solutions tailored to your needs.
          </p>
          <p className="text-foreground/80 text-lg leading-relaxed">
            From residential heating to commercial ventilation systems, we 
            prioritize indoor air quality, reliable performance, and transparent 
            communication. Your comfort is our commitment, year-round.
          </p>
        </div>

        {}
        <div ref={rightRef} className={rightVisible ? "animate-fade-in-up-delay-100" : "opacity-0"}>
          <Card className="overflow-hidden shadow-medium border-0">
            <img src="https://brief-deer.10web.cloud/wp-content/uploads/2026/01/image-2-1.png" alt="K&M Mechanical Services technicians working on HVAC system" className="w-full h-auto object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] hover:scale-[1.02]" />
          </Card>
        </div>
      </div>
    </section>;
}